import React, { useContext } from 'react';
import { ICreateDishContext, CreateDishContext } from '../../../createDishState/createDishContext';
import { MenuTranslationForm } from 'components/TranslationForm/MenuTranslationForm';

interface ITranslationsForm {
	isVisible: boolean;
}

const TranslationsForm: React.FC<ITranslationsForm> = ({ isVisible }) => {
	const {
		setFetchedTranslations,
		setTranslationTab,
		changeNameTranslation,
		changeDescriptionTranslation,
		selectedCustomer,
		translations,
		selectedTranslationTab,
	} = useContext<ICreateDishContext>(CreateDishContext);
	return (
		<MenuTranslationForm
			setFetchedTranslations={setFetchedTranslations}
			setTranslationTab={setTranslationTab}
			changeNameTranslation={changeNameTranslation}
			changeDescriptionTranslation={changeDescriptionTranslation}
			isVisible={isVisible}
			IDSelectedCustomer={selectedCustomer}
			translations={translations}
			selectedTranslationTab={selectedTranslationTab}
		/>
	);
};

export default TranslationsForm;
